import { FastTruckIcon } from '@reveni-io/reveni-ui'

import { parcelDirections } from '@/parcels/constants'
import routes from '@/Router/routes.constants'

import FastTruckReverseIcon from './FastTruckReverseIcon/FastTruckReverseIcon'

export const parcelTabs = [
  {
    label: 'Saliente',
    value: parcelDirections.outbound,
    icon: FastTruckReverseIcon,
    path: routes.parcelsPage.outbound,
  },
  { label: 'Entrante', value: parcelDirections.inbound, icon: FastTruckIcon, path: routes.parcelsPage.inbound },
]
